/* Peacock Life - Luxe PDP behaviour. Vanilla, no deps. */
(function () {
  'use strict';

  function money(cents, format) {
    var n = cents / 100;
    var s = n.toLocaleString('en-IN', { maximumFractionDigits: n % 1 === 0 ? 0 : 2 });
    return (format || '₹ {{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, s);
  }

  function LuxePDP(root) {
    this.root = root;
    this.data = JSON.parse(root.querySelector('[data-luxe-data]').textContent);
    this.idInput = root.querySelector('[data-luxe-variant-id]');
    this.selected = (this.data.selected || []).slice();
    this.init();
  }

  LuxePDP.prototype.init = function () {
    this.buildDims();
    this.bindOptions();
    this.bindGallery();
    this.bindSticky();
    this.bindLightbox();
    this.bindDrawer();
    this.render();
  };

  /* ---------- Dimensions: spec row + diagram ---------- */
  LuxePDP.prototype.buildDims = function () {
    var sizes = this.root.querySelectorAll('.lx-sizes .lx-size');
    if (sizes.length < 2) return;

    var specs = this.root.querySelector('.lx-specs');
    if (specs && !specs.querySelector('[data-luxe-dims]')) {
      var parts = [];
      sizes.forEach(function (b) {
        var n = b.querySelector('.lx-size__name');
        var d = b.querySelector('.lx-size__dim');
        if (!d) return;
        var name = n ? n.textContent.trim() : '';
        parts.push('<span data-dim="' + name.replace(/"/g, '') + '" style="display:block;margin-bottom:6px">' +
          '<b style="font-weight:400">' + name + '</b> — ' + d.textContent.trim() + '</span>');
      });
      if (parts.length) {
        var li = document.createElement('li');
        li.setAttribute('data-luxe-dims', '');
        li.innerHTML = '<span class="lx-specs__k">Dimensions</span><span class="lx-specs__v">' + parts.join('') + '</span>';
        var first = specs.firstElementChild;
        if (first) { specs.insertBefore(li, first.nextSibling); } else { specs.appendChild(li); }
      }
    }

    var box = this.root.querySelector('[data-luxe-dimbox]');
    if (box) box.hidden = false;
  };

  LuxePDP.prototype.syncDims = function () {
    var active = this.root.querySelector('.lx-sizes .lx-size[aria-pressed="true"]');
    var nameEl = active && active.querySelector('.lx-size__name');
    var dimEl = active && active.querySelector('.lx-size__dim');
    var name = nameEl ? nameEl.textContent.trim() : '';
    var dimText = dimEl ? dimEl.textContent.trim() : '';

    this.root.querySelectorAll('[data-luxe-dims] [data-dim]').forEach(function (s) {
      s.style.color = (name && s.getAttribute('data-dim') === name) ? 'var(--lx-ink)' : 'var(--lx-muted)';
    });

    var box = this.root.querySelector('[data-luxe-dimbox]');
    if (!box || !dimText) return;
    var unit = /cm/i.test(dimText) ? 'cm' : 'in';
    var nums = dimText.match(/\d+(?:\.\d+)?/g) || [];
    var w = box.querySelector('[data-luxe-dim-w]');
    var h = box.querySelector('[data-luxe-dim-h]');
    var lb = box.querySelector('[data-luxe-dim-label]');
    var nt = box.querySelector('[data-luxe-dim-note]');
    if (w) w.textContent = nums[0] ? nums[0] + ' ' + unit : '';
    if (h) h.textContent = nums[2] ? nums[2] + ' ' + unit : (nums[1] ? nums[1] + ' ' + unit : '');
    if (lb) lb.textContent = name;
    if (nt) nt.textContent = name ? (name + ' — ' + dimText + '. Custom sizing available on request.') : '';
  };

  /* ---------- options ---------- */
  LuxePDP.prototype.bindOptions = function () {
    var self = this;
    this.root.querySelectorAll('[data-luxe-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-luxe-option'), 10);
        self.selected[idx] = btn.getAttribute('data-value');
        self._userInteracted = true;
        self.render();
      });
    });
  };

  LuxePDP.prototype.currentVariant = function () {
    var sel = this.selected;
    return this.data.variants.filter(function (v) {
      return sel.every(function (val, i) { return v.options[i] === val; });
    })[0] || null;
  };

  LuxePDP.prototype.escape = function (s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  LuxePDP.prototype.render = function () {
    var self = this;
    var v = this.currentVariant();

    this.root.querySelectorAll('[data-luxe-option]').forEach(function (btn) {
      var idx = parseInt(btn.getAttribute('data-luxe-option'), 10);
      var val = btn.getAttribute('data-value');
      btn.setAttribute('aria-pressed', self.selected[idx] === val ? 'true' : 'false');
      var anyAvail = self.data.variants.some(function (x) { return x.options[idx] === val && x.available; });
      btn.setAttribute('data-unavailable', anyAvail ? 'false' : 'true');
    });

    this.syncDims();

    this.root.querySelectorAll('[data-luxe-chosen]').forEach(function (el) {
      var idx = parseInt(el.getAttribute('data-luxe-chosen'), 10);
      el.textContent = self.selected[idx] || '';
    });

    var priceEl = this.root.querySelector('[data-luxe-price]');
    var wasEl = this.root.querySelector('[data-luxe-was]');
    var saveEl = this.root.querySelector('[data-luxe-save]');
    var submit = this.root.querySelector('[data-luxe-submit]');
    var stickyPrice = this.root.querySelector('[data-luxe-sticky-price]');
    var stickySub = this.root.querySelector('[data-luxe-sticky-sub]');

    if (v) {
      if (this.idInput) this.idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price, this.data.moneyFormat);
      if (stickyPrice) stickyPrice.textContent = money(v.price, this.data.moneyFormat);
      var hasWas = v.compare_at_price && v.compare_at_price > v.price;
      if (wasEl) {
        wasEl.hidden = !hasWas;
        if (hasWas) wasEl.textContent = money(v.compare_at_price, this.data.moneyFormat);
      }
      if (saveEl) {
        saveEl.hidden = !hasWas;
        if (hasWas) saveEl.textContent = 'Save ' + money(v.compare_at_price - v.price, this.data.moneyFormat);
      }
      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available ? this.data.addLabel : this.data.soldOutLabel;
      }
      if (stickySub) stickySub.textContent = this.selected.join(' · ');
      if (v.featured_media_id) this.focusMedia(v.featured_media_id);
      if (window.history && window.history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        } catch (e) {}
      }
    } else if (submit) {
      submit.disabled = true;
      submit.textContent = this.data.unavailableLabel;
    }

    var line = this.data.title + (this.selected.length ? ' — ' + this.selected.join(', ') : '');
    var summary = this.root.querySelector('[data-luxe-drawer-summary]');
    if (summary) summary.innerHTML = '<b>' + this.escape(this.data.title) + '</b><br>' + this.escape(this.selected.join(' · '));
    this.root.querySelectorAll('[data-luxe-wa]').forEach(function (a) {
      var num = a.getAttribute('data-luxe-wa');
      var msg = a.getAttribute('data-luxe-wa-msg') || 'Hi Peacock Life,';
      a.href = 'https://wa.me/' + num + '?text=' + encodeURIComponent(msg + '\n\n' + line + '\n' + self.data.url);
    });
  };

  LuxePDP.prototype.bindGallery = function () {
    var self = this;
    this.rail = this.root.querySelector('[data-luxe-rail]');
    this.dots = this.root.querySelectorAll('[data-luxe-dot]');
    if (!this.rail || !this.dots.length) return;
    this.rail.addEventListener('scroll', function () {
      var step = self.rail.scrollWidth / self.dots.length;
      var i = Math.round(self.rail.scrollLeft / step);
      self.dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }, { passive: true });
    this.dots.forEach(function (d, j) {
      d.addEventListener('click', function () {
        self.rail.scrollTo({ left: j * (self.rail.scrollWidth / self.dots.length), behavior: 'smooth' });
      });
    });
  };

  LuxePDP.prototype.focusMedia = function (mediaId) {
    if (this._lastMedia === mediaId) return;
    this._lastMedia = mediaId;
    if (!this._userInteracted) return;
    var target = this.root.querySelector('[data-luxe-media="' + mediaId + '"]');
    if (target && window.matchMedia('(min-width: 990px)').matches) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  LuxePDP.prototype.bindSticky = function () {
    var self = this;
    var bar = this.root.querySelector('[data-luxe-sticky]');
    var anchor = this.root.querySelector('[data-luxe-buy]');
    if (!bar || !anchor) return;
    var tick = false;
    function update() {
      var r = anchor.getBoundingClientRect();
      var nearFoot = window.innerHeight + window.scrollY > document.body.scrollHeight - 140;
      bar.setAttribute('data-visible', r.bottom < 0 && !nearFoot ? 'true' : 'false');
      tick = false;
    }
    window.addEventListener('scroll', function () {
      if (!tick) { tick = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
    var stickyAdd = bar.querySelector('[data-luxe-sticky-add]');
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        var btn = self.root.querySelector('[data-luxe-submit]');
        if (btn && !btn.disabled) btn.click();
      });
    }
  };

  LuxePDP.prototype.bindLightbox = function () {
    var self = this;
    var box = this.root.querySelector('[data-luxe-lightbox]');
    if (!box) return;
    var img = box.querySelector('img');
    this.root.querySelectorAll('[data-luxe-zoom]').forEach(function (el) {
      el.addEventListener('click', function () {
        img.src = el.getAttribute('data-luxe-zoom');
        img.alt = el.getAttribute('data-luxe-alt') || '';
        self.open(box);
      });
    });
    box.querySelectorAll('[data-luxe-close]').forEach(function (c) {
      c.addEventListener('click', function () { self.close(box); });
    });
  };

  LuxePDP.prototype.bindDrawer = function () {
    var self = this;
    var drawer = this.root.querySelector('[data-luxe-drawer]');
    if (!drawer) return;
    this.root.querySelectorAll('[data-luxe-drawer-open]').forEach(function (b) {
      b.addEventListener('click', function () { self.open(drawer); });
    });
    drawer.querySelectorAll('[data-luxe-close]').forEach(function (c) {
      c.addEventListener('click', function () { self.close(drawer); });
    });
  };

  LuxePDP.prototype.open = function (el) {
    el.setAttribute('data-open', 'true');
    document.documentElement.style.overflow = 'hidden';
    this._esc = function (e) { if (e.key === 'Escape') this.close(el); }.bind(this);
    document.addEventListener('keydown', this._esc);
  };

  LuxePDP.prototype.close = function (el) {
    el.setAttribute('data-open', 'false');
    document.documentElement.style.overflow = '';
    if (this._esc) document.removeEventListener('keydown', this._esc);
  };

  function boot() {
    document.querySelectorAll('[data-luxe-pdp]').forEach(function (r) {
      if (!r.__luxe) r.__luxe = new LuxePDP(r);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
